import { render } from "./PageRegister.vue?vue&type=template&id=0267367e&scoped=true"
import script from "./PageRegister.vue?vue&type=script&lang=js"
export * from "./PageRegister.vue?vue&type=script&lang=js"

import "./PageRegister.vue?vue&type=style&index=0&id=0267367e&lang=scss&scoped=true"

import exportComponent from "/Users/simonkravec/weby/zmen-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0267367e"]])

export default __exports__